/**
 * IMPORTS
 */

import { historicoRemessaRepository } from "@/repositories/historico-de-remessa-do-cliente";

/**
 * Função que busca histórico de remessas do cliente 🛠️.
 */
const handleGetHistoricoRemessa = async (
  accessToken: string,
  cliente_id: number,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await historicoRemessaRepository.getAllHistoricoRemessa(
      accessToken,
      cliente_id,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM BUSCAR HISTORICOS DE REMESSAS:", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleGetHistoricoRemessa };
